<template>

</template>

<script>
    export default {
        props: ['user'],
        data() {
            return {
            }
        },
        created() {

            if(!this.getCookie('registered_' + this.user.id)) {

                fbq('track', 'CompleteRegistration',
                    {
                        value: this.user.email,
                        status: 'registration_completed',
                        content_name: 'registration_confirmation',
                        currency: 'EUR'
                    }
                );

                this.setCookie('registered_' + this.user.id,'1','30');
            }

        },
        mounted() {

        },
        methods: {
            setCookie(key, value, expiry) {
                let expires = new Date();
                expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
                document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
            },
            getCookie(key) {
                let keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
                return keyValue ? keyValue[2] : null;
            }
        },
        beforeDestroy() {

        },
    }
</script>
